import moment from 'moment';
import { convertToMoney, convertToNumberFormat } from '../../../../../../../common/functions/numeric';

export default class Apuracao {

  constructor(titulo, id, idAcordo, apuracao) {
    moment.locale('pt-BR');
    this._titulo = titulo;
    this._id = id;
    this._idAcordo = idAcordo;
    this._idMeta = apuracao.idMeta;
    this._statusApuracao = apuracao.status;
    this._tipoAcordo = apuracao.codTipoAcordo;
    this._tipo = apuracao.descTipoAcordo;
    this._descricao = apuracao.descricao;
    this._dataInicio = apuracao.dtaInicio;
    this._dataFinal = apuracao.dtaFim;
    this._periodoDe = apuracao.periodoDe;
    this._periodoAte = apuracao.periodoAte;
    this._solicitante = apuracao.solicitante;
    this._codCliente = apuracao.codCliente;
    this._cliente = apuracao.nomCliente;
    this._contratoCliente = apuracao.contratoCliente;
    this._codClientePagador = apuracao.codClientePag;
    this._clientePagador = apuracao.nomClientePag;
    this._holding = apuracao.descFiltro;
    this._regiao = apuracao.descFiltro;
    this._filtroCliente = apuracao.nomFiltroCliente;
    this._tipoBeneficio = apuracao.codTipoBeneficio;
    this._descTipoBeneficio = apuracao.descTipoBeneficio;
    this._banco = apuracao.nomBanco;
    this._agencia = apuracao.vlrAgencia;
    this._contaCorrente = apuracao.vlrConta;
    this._evidencia = apuracao.evidencia;
    this._marca = apuracao.marca;
    this._linhaDeProduto = apuracao.linhaProduto;
    this._familia = apuracao.familia;
    this._produto = apuracao.produto;
    this._valorMeta = apuracao.vlrMeta;
    this._valorRelizado = apuracao.realizadoMeta;
    this._valorNegociado = apuracao.vlrNegociado;
    this._valorPagamento = apuracao.vlrPagamento;
    this._precoNegociado = apuracao.precoNegociacao;
    this._tipoBonificacao = apuracao.tipoBonificacao;
    this._tipoMetaBeneficio = apuracao.tipoMetaBeneficio;
    this._unidadeMedida = apuracao.unidadeMedida;
    this._baseCalculoApuracao = apuracao.baseCalculoApuracao;
    this._justificativa = apuracao.justificativa;
    this._aprovador = !!apuracao.aprovador;
    this._metas = apuracao.metas;
  }

  get id() {
    return this._id;
  }

  get status() {
    return this._statusApuracao;
  }

  set status(value) {
    this._statusApuracao = value;
  }

  get exibirAprovado() {
    return this._statusApuracao === 'APROVADO' || this._statusApuracao === 'AGUARDANDO_APROVACAO';
  }

  get exibirAnalisar() {
    return this._statusApuracao === 'EM_ANALISE' || (this._statusApuracao === 'AGUARDANDO_APROVACAO' && this._aprovador);
  }

  get exibirReprovado() {
    return this._statusApuracao === 'REPROVADO' || (this._statusApuracao === 'AGUARDANDO_APROVACAO' && this._aprovador);
  }

  get naoExecutarAcoes() {
    return this._statusApuracao === 'APROVADO' || this._statusApuracao === 'EM_ANALISE' || this._statusApuracao === 'REPROVADO' || !this._aprovador;
  }

  get exibirJustificativa() {
    return this._justificativa && this._justificativa.length && this.naoExecutarAcoes;
  }

  get ehValor() {
    return this._tipoMetaBeneficio === 'SELLOUT_VALOR' ||
      this._tipoMetaBeneficio === 'SELLIN_VALOR';
  }

  get tipoMetaBeneficio() {
    return this._tipoMetaBeneficio;
  }

  get tipoBonificacao() {
    return this._tipoBonificacao;
  }

  get baseCalculoApuracao() {
    return this._baseCalculoApuracao;
  }

  get unidadeMedida() {
    return this._unidadeMedida;
  }

  get ehPercentual() {
    return this._tipoBonificacao === 'PERCENTUAL';
  }

  get titulo() {
    return `${this._titulo} ${this._idAcordo} :: ${this._tipo} :: ${this._solicitante}`;
  }

  get descricao() {
    return this._descricao;
  }

  get dataInicio() {
    return moment(this._dataInicio, 'YYYY-MM-DD').format('DD-MM-YYYY');
  }

  get dataFinal() {
    return moment(this._dataFinal, 'YYYY-MM-DD').format('DD-MM-YYYY');
  }

  get periodo() {
    if (this._periodoAte > this._periodoDe) {
      return `${moment(this._periodoDe, 'YYYYMM').format('MMMM/YYYY')} à ${moment(this._periodoAte, 'YYYYMM').format('MMMM/YYYY')}`;
    }
    return moment(this._periodoDe, 'YYYYMM').format('MMMM/YYYY');
  }

  get contratoCliente() {
    return this._contratoCliente;
  }

  get clientePagador() {
    return `${this._codClientePagador} - ${this._clientePagador}`;
  }

  get descTipoBeneficio() {
    return this._descTipoBeneficio;
  }

  get ehDepositoEmConta() {
    return this._tipoBeneficio === 'DEPOSITO_CONTA';
  }

  get contaCorrente() {
    return `${this._banco} - ${this._agencia} - ${this._contaCorrente}`;
  }

  get ehMetaComContraPartida() {
    return this.ehCrescimento || this.ehNegociacaoPreco || this.ehPositivacao;
  }

  get ehPositivacaoOuNegociacaoPreco() {
    return this.ehPositivacao || this.ehNegociacaoPreco;
  }

  get ehCrescimentoOuNegociacaoPreco() {
    return this.ehCrescimento || this.ehNegociacaoPreco;
  }

  get ehPositivacao() {
    return this._tipoAcordo === 'POSITIVACAO';
  }

  get ehNegociacaoPreco() {
    return this._tipoAcordo === 'NEGOCIACAO_PRECO';
  }

  get ehCrescimento() {
    return this._tipoAcordo === 'CRESCIMENTO';
  }

  get ehTabloide() {
    return this._tipoAcordo === 'TABLOIDE';
  }

  get cliente() {
    return this._cliente;
  }

  get codCliente() {
    return this._codCliente;
  }

  get ehCliente() {
    return this._filtroCliente === 'id_cliente';
  }

  get holding() {
    return this._holding;
  }

  get ehHolding() {
    return this._filtroCliente === 'id_holding';
  }

  get ehRegiao() {
    return this._filtroCliente === 'id_regiao';
  }

  get valorMeta() {
    return this.exibirMeta(this._valorMeta);
  }

  get valorRelizado() {
    return this.exibirMeta(this._valorRelizado);
  }

  get valorNegociado() {
    return convertToMoney(this._valorNegociado);
  }

  get valorPagamento() {
    return convertToMoney(this._valorPagamento);
  }

  get precoNegociado() {
    return convertToMoney(this._precoNegociado);
  }

  get evidencia() {
    return this._evidencia;
  }

  get marca() {
    return this._marca;
  }

  get linhaDeProduto() {
    return this._linhaDeProduto;
  }

  get familia() {
    return this._familia;
  }

  get produto() {
    return this._produto;
  }

  get metasCrescimento() {
    return this._metas;
  }

  get justificativa() {
    return this._justificativa;
  }

  set justificativa(value) {
    this._justificativa = value;
  }

  get idMeta() {
    return this._idMeta;
  }

  exibirMeta(valor) {
    if (this.ehValor) {
      return convertToMoney(valor);
    }
    return convertToNumberFormat(valor);
  }

}



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/apuracao/pendencias/Apuracao.js